module.exports = __webpack_public_path__ + "img/no-transactions.ae692cee.png";